import DesktopSwitch from '../../components/DesktopSwitch';
import ProfileSelf from './ProfileSelf';
import ProfileDesktop from './ProfileDesktop';

function ProfilePage() {
  return (
    <DesktopSwitch desktop={ProfileDesktop} mobile={ProfileSelf} />
  );
}

export default ProfilePage;
